import { render, staticRenderFns } from "./LayoutImpressao.vue?vue&type=template&id=95be4a1a"
import script from "./LayoutImpressao.vue?vue&type=script&lang=js"
export * from "./LayoutImpressao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports